// src/Components/CommunitySlider.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

const CommunitySlider = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const bannersSnapshot = await getDocs(collection(db, "banners"));
        const bannersData = bannersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSlides(bannersData);
      } catch (err) {
        console.error("Ошибка при загрузке баннеров:", err);
      }
    };

    fetchBanners();
  }, []);

  if (!slides.length) return <p className="text-gray-400">Нет баннеров</p>;

  return (
    <div className="w-full overflow-x-scroll scrollbar-hide">
      <div className="flex space-x-2 py-2">
        {slides.map((slide, index) => (
          <div
            key={slide.id || index}
            className="min-w-[80%] sm:min-w-[60%] max-w-sm bg-white rounded-2xl shadow-md overflow-hidden flex-shrink-0 cursor-pointer"
            onClick={() => slide.link && window.open(slide.link, "_blank")}
          >
            <img
              src={slide.imageUrl}
              alt={`Slide ${index + 1}`}
              className="w-full h-40 object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunitySlider;
